<template>
    <a style="color:var(--primary)" class="text--bold" :class="{ botaoGruposDisponiveis: !tipoEstiloBotao,botaoTermoAditamento: tipoEstiloBotao }" @click.stop.prevent="getRegrasAditamentoGrupo">
        TERMO DE ADITAMENTO
    </a>
</template>
<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../plugins/alerts_types'
  export default {
    name: 'AditamentoButton',
    props: {
      idPlanoVenda: { Number, default: 0 },
      /*
      O tipoEstiloBotao há 2 modos:
      True -> Alinha o botão á direita, junto com os botões padrão da rodobens
      False -> Deixa sem estilo e diminui a letra
      */
      tipoEstiloBotao: { Boolean, default: false }
    },
    methods: {
      showPdfInNewTab (base64Data) {
        // eslint-disable-next-line no-useless-escape
        var link = 'data:application/pdf;base64,' + base64Data.replace(/[\”]/g, '')
        fetch(link).then(res => res.blob()).then(res => window.open(URL.createObjectURL(res), '_blank'))
      },
      async getRegrasAditamentoGrupo () {
        await this.$http.get(`/contratos/aditamento/pdf/${this.idPlanoVenda}`, { silent: false }).then((response) => {
          this.showPdfInNewTab(response.data)
        }).catch(() => {
          notification(AlertTypes.ERROR, 'Falha ao consultar o Termo de Aditamento do grupo em questão!')
        })
      }
    }
  }
</script>

<style lang='scss' scoped>

.botaoTermoAditamento {

    position: absolute;
    right: 20px;
    text-decoration: underline;
    max-width: 255px;

    @media(max-width:1600px) {
        max-width: 200px;
        letter-spacing: 0px;
        word-spacing: 0px;
        font-size: 12px;
    }

}
.botaoGruposDisponiveis {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: underline;
    text-align: center;
    color: inherit;
    font-size: 15px;
    @media(max-width:1600px) {
        letter-spacing: 0px;
        word-spacing: 0px;
    }

    @media (max-width: 1280px) {
        letter-spacing: 0px;
        word-spacing: 0px;
        font-size: 14px;
    }
}
</style>
